import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import moment from 'moment';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContractsService {

  constructor(
    private http: HttpClient
  ) { }
  create(contract) {
    return this.http.post(`${environment.apiUrl}/globalvision/contract/create`, contract,{
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }
  update(contract) {
    return this.http.post(`${environment.apiUrl}/globalvision/contract/update`, contract,{
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }
  getAssociatedContract() {
    return this.http.get(`${environment.apiUrl}/globalvision/contract/associated`, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }

  getCriticalContract(providerId) {
    return this.http.post(`${environment.apiUrl}/globalvision/contract/criticalityContract`, providerId, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }

  getExpirations() {
    return this.http.get(`${environment.apiUrl}/globalvision/contract/nextExpiration`, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }
  getNextExpiration(providerId) {
    return this.http.post(`${environment.apiUrl}/globalvision/contract/nextExpiration`, providerId,{
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }

  getUpcomingContractExpirations(providerId) {
    return this.http.post(`${environment.apiUrl}/globalvision/contract/upcomingContractExpirations`, providerId,{
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }

  getRenewals() {
    return this.http.get(`${environment.apiUrl}/globalvision/contract/renewal`, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }

  search() {
    return this.http.get(`${environment.apiUrl}/globalvision/contract/search`, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }

  getCustomField() {
    return this.http.post(`${environment.apiUrl}/globalvision/customfield/suggest`, {type: "contract"},{
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }
  getAllCurrencys() {
    return this.http.get(`${environment.apiUrl}/globalvision/currency`, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }
  getAllContractKinds() {
    return this.http.get(`${environment.apiUrl}/globalvision/contractkind`, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }
  getHistory(id: number) {
    return this.http.get(`${environment.apiUrl}/globalvision/contract/history/${id}`, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    })
  }
  getContractId(id:number) {
    return this.http.post(`${environment.apiUrl}/globalvision/contract/get/${id}`, {type: "contract"},{
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }
  parseDate(date){
    let dateFormat = moment(date, "DD/MM/YYYY");
    return dateFormat.format('YYYY-MM-DD');
  }
  async relatecontracts(contract):Promise<any> {
    return this.http.post(`${environment.apiUrl}/globalvision/contract/relatecontracts`, contract,{
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    }).toPromise();
  }
  droprelation(contract) {
    return this.http.post(`${environment.apiUrl}/globalvision/contract/droprelation`, contract,{
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }

  deleteContract(contract) {
    return this.http.post(`${environment.apiUrl}/globalvision/contract/delete`, contract,{
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }
}